
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ExpenseForm } from "./ExpenseForm";
import { useHouses } from "@/hooks/useHouses";
import { usePlot } from "@/hooks/usePlot";
import { useExpenseFormState } from "./ExpenseFormState";

interface ExpenseDialogProps {
  onExpenseCreated: () => void;
  entityType?: 'house' | 'plot';
  plotId?: string;
}

export const ExpenseDialog = ({ onExpenseCreated, entityType = 'house', plotId }: ExpenseDialogProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { houses } = useHouses();
  const { plot } = usePlot(plotId);
  
  const {
    selectedEntity,
    setSelectedEntity,
    amount,
    setAmount,
    category,
    setCategory,
    description,
    setDescription,
    expenseDate,
    setExpenseDate,
    handleCreateExpense,
  } = useExpenseFormState({
    onExpenseCreated,
    onClose: () => setIsDialogOpen(false),
    entityType
  });

  // Get the appropriate entities based on entityType
  const entities = entityType === 'house' ? houses : (plotId ? [plot].filter(Boolean) : []);

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button className="w-full h-12">
          <PlusIcon className="h-4 w-4 mr-2" />
          Nuevo gasto {entityType === 'plot' ? 'de parcela' : ''}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-2xl">
            Nuevo gasto {entityType === 'plot' ? 'de parcela' : ''}
          </DialogTitle>
        </DialogHeader>
        <ExpenseForm
          entities={entities}
          selectedEntity={selectedEntity}
          amount={amount}
          category={category}
          description={description}
          expenseDate={expenseDate}
          onEntityChange={setSelectedEntity}
          onAmountChange={setAmount}
          onCategoryChange={setCategory}
          onDescriptionChange={setDescription}
          onExpenseDateChange={setExpenseDate}
          entityType={entityType}
          defaultEntity={plotId}
        />
        <Button onClick={handleCreateExpense} className="w-full">
          Crear Gasto
        </Button>
      </DialogContent>
    </Dialog>
  );
};
